import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashNav from '../Dashboard/DashNav';
import '../Dashboard/GameDashboard.css';
import './InstructionsPage.css';

// Instructions tab: full game-board reference + rules summary, reachable from
// the mansion home menu. The board SVG is a static asset so players can study
// the layout, numbers, and point values.
const InstructionsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="instructions-page">
      <div className="instructions-page__container">
        <div className="instructions-page__header">
          <h1 className="instructions-page__title">How To Play</h1>
          <button
            onClick={() => navigate('/game')}
            className="instructions-page__close"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <img
          src="/images/bitwheel-gameboard.svg"
          alt="42 Bit Wheel game board: numbers, colors, and point values"
          className="instructions-page__board"
        />

        <div className="instructions-page__card">
          <div className="instructions-page__card-label">The Two Ledgers</div>
          <ul className="instructions-page__list">
            <li>
              <b>10 Spin Points</b> — each game draws 10 spins from your
              balance, and those become your wager markers. Spend 0, 1, or 2
              per spin to set your multiplier. Once spent, they&apos;re gone —
              they never mix into your score.
            </li>
            <li>
              <b>Score</b> — starts at 0 and only ever grows. Every payout lands
              here. This is your high score!
            </li>
          </ul>
        </div>

        <div className="instructions-page__card">
          <div className="instructions-page__card-label">Each Spin</div>
          <ul className="instructions-page__list">
            <li>Pick a <b>wager</b> (0, 1, or 2 spin points), a <b>color</b>, and optionally a <b>number</b> (1–42).</li>
            <li>
              <b>Call it to win it:</b> you score when your <b>color</b> or your{' '}
              <b>number</b> hits. On a hit, payout ={' '}
              <code className="instructions-page__formula">
                segmentValue × wager × colorBonus × numberBonus
              </code>
            </li>
            <li>Miss both? No points this spin — line up the next call and keep swinging!</li>
            <li>Wager 0 = observe the spin. Very little risk — great for learning the wheel!</li>
          </ul>
        </div>

        <div className="instructions-page__card">
          <div className="instructions-page__card-label">Multipliers</div>
          <table className="instructions-page__table">
            <tbody>
              <tr><td>Exact number hit</td><td className="instructions-page__mult">42×</td></tr>
              <tr><td>Green color match</td><td className="instructions-page__mult">7×</td></tr>
              <tr><td>Yellow color match</td><td className="instructions-page__mult">6×</td></tr>
              <tr><td>Blue / Orange color match</td><td className="instructions-page__mult">3×</td></tr>
            </tbody>
          </table>
        </div>

        <div className="instructions-page__card">
          <div className="instructions-page__card-label">The Game</div>
          <ul className="instructions-page__list">
            <li><b>10 spins per game.</b> Finish with the highest score you can.</li>
            <li>
              10 spin points across 10 spins means you can&apos;t wager 2 every
              time — budgeting your markers IS the strategy.
            </li>
            <li>Max single spin: wager 2 + green + exact #1 or #22 = <b>+588,000</b>!</li>
          </ul>
        </div>

        <button
          className="instructions-page__play"
          onClick={() => navigate('/game')}
        >
          PLAY NOW
        </button>

        <DashNav />
      </div>
    </div>
  );
};

export default InstructionsPage;
